import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { DialogRootEmits, DialogRootProps } from "reka-ui"
import { DialogRoot, useForwardPropsEmits } from "reka-ui"


export default /*@__PURE__*/_defineComponent({
  __name: 'Sheet',
  props: {
    open: { type: Boolean },
    defaultOpen: { type: Boolean },
    modal: { type: Boolean }
  },
  emits: ["update:open"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

const forwarded = useForwardPropsEmits(props, emits)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogRoot), _mergeProps({ "data-slot": "sheet" }, _unref(forwarded)), {
    default: _withCtx((slotProps) => [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(slotProps)))
    ]),
    _: 3
  }, 16))
}
}

})